const defaultState = {
    report: {},
    error: null,
    fetching: false,
    fetched: false
};

const getPortfolioAlertsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case 'PORTFOLIO_ALERTS_CLEAR': {
            return {
                ...state, fetching: false, fetched: true, error: null, report: null
            };
        }
        case 'PORTFOLIO_ALERTS_FETCH_PENDING': {
            return {
                ...state, error: null, fetching: true, report: {}
            };
        }
        case 'PORTFOLIO_ALERTS_FETCH_FULFILLED': {
            return {
                ...state, fetching: false, fetched: true, error: null, report: action.payload.data
            };
        }
        case 'PORTFOLIO_ALERTS_FETCH_REJECTED': {
            return {
                ...state,
                fetching: false,
                fetched: false,
                report: {},
                error: action.payload
            };
        }
        default: {
            break;
        }
    }

    return state;
};

export default getPortfolioAlertsReducer;


// WEBPACK FOOTER //
// ./src/reducers/getPortfolioAlerts.js